import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ClienteAdmCadastro from '../componentsPage/ClienteAdmCadastro'
import ClienteWhatsapp from '../componentsPage/ClienteWhatsapp'
import ClienteUsuarios from '../componentsPage/ClienteUsuarios'
import Badge from 'react-bootstrap/Badge';


const ModalAdmCliente = (props: any) => {

    const [key, setKey] = useState<string | null>('dadosGerais')
    const [show, setShow] = useState(props.show)
    
    const [totalUsuarios, setTotalUsuarios] = useState(0)
    const [totalWhatsapp, setTotalWhatsapp] = useState(0)

    const [cliente_id, setCliente_id] = useState(props.cliente_id)

    useEffect(() => {

        
        setShow(props.show);
        setCliente_id(props.cliente_id)
        setTotalUsuarios(0)
        setTotalWhatsapp(0)
        setKey('dadosGerais')
                
    }, [props.show, props.cliente_id, props.now]);


    return (

        <div>

            <Modal
                
                show={show}
                fullscreen={true}
                onHide={() => setShow(false)}
                aria-labelledby="example-modal-sizes-title-xl"
                dialogClassName="modal-fullscreen-fix"
                
                >
                <Modal.Header closeButton>
                <Modal.Title id="example-modal-sizes-title-xl">

                    Cliente

                </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                <div className="row g-3">

                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key ?? "dadosGerais"}
                        onSelect={(k) => setKey(k)}
                        className="mb-3"
                        >


                            <Tab eventKey="dadosGerais" title={
                                
                                    <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                        <i
                                            className="material-icons-outlined">person_outline</i>
                                        Dados Empresariais

                                    </div>
                                
                            }>

                                <ClienteAdmCadastro setShow={props.setShow} cliente_id={cliente_id} setCliente_id={setCliente_id} />

                            </Tab>

                        {
                            props.cliente_id != undefined && (

                                <Tab eventKey="dadosCobranca" title={
                                    <>
                                        <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                            <i className="material-icons-outlined">group</i>
                                            Notificações Whatsapp
                                            <Badge style={{ fontSize: '0.7rem' }} bg='primary'>{totalWhatsapp}</Badge>
                                        </div>
                                    </>
                                }>
    
                                    <ClienteWhatsapp setShow={props.setShow} cliente_id={cliente_id} setTotalWhatsapp={setTotalWhatsapp} />
    
    
                                </Tab>

                            )

                        }
                        {
                            props.cliente_id != undefined && (

                                <Tab eventKey="dadosUsuarios" title={
                                    <>
                                        <div className="dropdown-item d-flex align-items-center gap-2 py-2">
                                            <i className="material-icons-outlined">group</i>
                                            Usuários
                                            <Badge style={{ fontSize: '0.7rem' }} bg='warning'>{totalUsuarios}</Badge>
                                        </div>
                                    </>
                                }>
    
                                    <ClienteUsuarios setShow={props.setShow} cliente_id={cliente_id} setTotalUsuarios={setTotalUsuarios} />
    
    
                                </Tab>

                            )
                        }

                            

                    </Tabs>

                    </div>

                </Modal.Body>


            </Modal>


        </div>

    )

}

export default ModalAdmCliente